<div class="container-fluid">
  <div *ngIf="loading; else loaded">
    <app-loading></app-loading>
  </div>

  <ng-template #loaded>
    <!-- Tiêu Đề Trang với Biểu Tượng -->
    <h1 class="h3 mb-2 text-gray-800">
      <i class="fas fa-exchange-alt"></i> {{ circulationI18n?.allTitleI18n }}
    </h1>
    
    <!-- Mô Tả -->
    <p class="lead">Quản lý và theo dõi việc lưu thông các mục một cách hiệu quả. Sử dụng các công cụ được cung cấp để thêm, chỉnh sửa, xem, liên hệ và xóa các bản ghi lưu thông một cách dễ dàng.</p>

    <!-- Ví Dụ DataTales -->
    <div class="card shadow mb-4">
      <div class="card-body">
        <div class="table-responsive">
          
          <app-circulation-list
            (editEvent)="edit($event)"
            (viewEvent)="view($event)"
            (contactEvent)="contact($event)"
            (deleteEvent)="delete($event)"
            [circulations]="circulations$"
            [circulationI18n]="circulationI18n"
          ></app-circulation-list>
          <app-circulation-modal
            [email]="email"
            [circulationI18n]="circulationI18n"
            [circulations]="circulations$"
            [id]="id"
          ></app-circulation-modal>
        </div>
      </div>
    </div>
  </ng-template>
</div>

